import HtmlTrans from 'components/shared/HtmlTrans';
import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import ApplicationsMonthly from '../charts/ApplicationsMonthly';
import ApplicationsWeekly from '../charts/ApplicationsWeekly';
import {
  StyledApplicationsContent,
  StyledCard,
  StyledCardTitle,
  StyledContainer
} from './Candidates.styled';

const Applications: React.FC = () => {
  const { t } = useI18n('state-of-hiring');

  return (
    <StyledContainer>
      <StyledApplicationsContent>
        <div>
          <Heading2 editorial alignLeft>
            {t('state-of-hiring.candidates.applications.title')}
          </Heading2>
          <div>
            <HtmlTrans
              i18nKey="state-of-hiring.candidates.applications.content"
              ns="state-of-hiring"
            />
          </div>
        </div>
        <div>
          <StyledCard>
            <StyledCardTitle>
              {t('state-of-hiring.candidates.applications.monthly')}
            </StyledCardTitle>
            <ApplicationsMonthly />
          </StyledCard>
          <StyledCard>
            <StyledCardTitle>
              {t('state-of-hiring.candidates.applications.weekly')}
            </StyledCardTitle>
            <ApplicationsWeekly />
          </StyledCard>
        </div>
      </StyledApplicationsContent>
    </StyledContainer>
  );
};

export default Applications;
